<script>
import $ from "jquery";
import ubicacion from "../constantes/ubicacion.json"
import { encryptData, decryptData } from '../constantes/encrypt';

export default {
    props: ['header', 'APIS', 'form'],
    data: function () {
        return {
            ubicaciones: ubicacion,
            coordinates: [-78.183406, -1.831239],
            center: { lat: 39.7837304, lng: -100.4458825 },
            email_user: this.$session.get("email"),
            dni: this.$session.get("dni"),
            citys: null,
            parroquis: null,
            province: "",
            city: "",
            parroqui: "",
            base64:null
        }
    },
    methods: {
        validate: function (a, b) {
            var e = $("#" + a).val();
            var reg = /^\d+$/;
            if (b == 1) {
                if (!reg.test(e)) {
                    $("#" + a).val("");
                }
            } else {
                var numeros = "0123456789";
                for (var i = 0; i < e.length; i++) {
                    if (numeros.indexOf(e.charAt(i), 0) != -1) {
                        $("#" + a).val("");
                    }
                }
            }
        },
        coordStreetGoogle(component) {
            this.coordinates = [component.latLng.lng(), component.latLng.lat()];
        },
        submitForm: async function () {
            const formData = new FormData(this.$refs["data-personal2"]); // reference to form element
            const data = {}; // need to convert it before using not with XMLHttpRequest
            for (let [key, val] of formData.entries()) {
                if(val.type == "application/pdf"){

                    const base64Data = await this.leerArchivo(val);
                    const myHeaders = new Headers();
                    myHeaders.append("Authorization", "#$TIK33!@#_Q@#$wIASDMAS123");
                    myHeaders.append("Content-Type", "application/json");

                    const raw = JSON.stringify({
                        "base64Data": base64Data,
                        "folderName": "marcimex",
                        "fileName": "cedula"+ this.$session.get("dni"),
                        "format": "pdf"
                    });

                    const requestOptions = {
                        method: "POST",
                        headers: myHeaders,
                        body: raw,
                        redirect: "follow"
                    };
                    const results = await this.realizarSolicitud(requestOptions);
                    if(!results.status){
                        alert('Archivo no admitido')
                        return;
                    }
                    Object.assign(data, { [key]: results.url });

                }else{
                    Object.assign(data, { [key]: val });
                }
            }
            // // Object.assign(data, { ["provincia_txt"]: this.ubicaciones[this.province].provincia });
            // // Object.assign(data, { ["ciudad_txt"]: this.ubicaciones[this.province].cantones[this.city].canton });
            const headers = {
                lat: this.header.latitud,
                long: this.header.longitud,
                Authorization: "Bearer " + this.header.token,
            };
        

            const body = {
                    data: encryptData({
                idEntity: this.header.idEntity,
                email: this.email_user,
                dni: this.dni,
                "process":"GET_TERMS",
            })
        }
            //URL DE OBTENCIÓN DE TERMINOS
            this.elemetsTerm = [];
            this.$http.post(this.APIS[2].name, body, { headers })
                .then((response) => {
                    if (response.status == 200) {

                        this.numbersteps = 4;
                        response.data =  decryptData(response.data)
                        this.$emit("successApi", data, response.data);
                        $("html, body").animate(
                            { scrollTop: $("#navs").offset().top },
                            2000
                        );
                    } else {
                        this.$modal.show("modalError");
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.$modal.show("modalError");
                });
        },
        async  realizarSolicitud(requestOptions) {
            try {

                const response = await fetch( "https://fintech.kradac.com:3011"+"/api/v1/filesUpload", requestOptions);
                const result = await response.json();


                return result; // Puedes devolver el resultado si es necesario
            } catch (error) {
                console.log(error)
            }
        },
        leerArchivo(val) {
            return new Promise((resolve, reject) => {
                const lector = new FileReader();

                lector.onload = () => {
                    const base64Data = lector.result.split(",")[1] || "";
                    this.base64 = base64Data;
                    resolve(base64Data);
                };

                lector.onerror = (error) => {
                    reject(error);
                };

                lector.readAsDataURL(val);
            });
        },
        changeProvince() {
            //const now = this.ubicaciones.find(element => element.provincia == this.province);
            //var as = JSON.parse(this.ubicaciones);
            this.city = "";
            this.parroqui = ""
            this.citys = this.ubicaciones[this.province].cantones;

        },
        changeCity() {
            this.parroqui = ""
            this.parroquis = this.citys[this.city].parroquias;
        },
         validarArchivo(event) {
            const input = event.target;
            const archivo = input.files[0];

            // Verificar si se seleccionó un archivo
            if (!archivo) {
                alert('Por favor, selecciona un archivo.')
                return;
            }

            // Verificar la extensión del archivo
            const extension = archivo.name.split('.').pop().toLowerCase();
            if (extension !== 'pdf') {
                alert('Solo se permiten archivos PDF.');
                input.value = ''; // Limpiar el campo de archivo
                return;
            }

            // Verificar el tamaño del archivo (en bytes)
            const tamañoMaximo = 1 * 1024 * 1024; // 2 MB
            if (archivo.size > tamañoMaximo) {
                alert('El archivo debe ser menor o igual a 2 MB.')
                input.value = ''; // Limpiar el campo de archivo
                return;
            }
        }

    }
};
</script>
<template>
    <div class="container-data-personal">
        <form ref="data-personal2" id="data-personal2" @submit.prevent="submitForm">
            <br />
            <div v-for="item in form" v-bind:key="item.id" class="param-data-personal">
                <label :for="item.key">{{ item.nombre }}</label>
                <!--v-on:keyup="validate(item.identificador, item.validador)" -->
                <input v-if="item.tipo == 'file'" type="file" id="pdf" :name="item.identificador" accept=".pdf"   @change="validarArchivo($event)" :required="item.requerido"/>
                
                <input v-if="item.tipo != 'combobox' && item.tipo != 'file'" :name="item.identificador"
                    onkeyup="this.value = this.value.toUpperCase();" :type="item.tipo" :id="item.identificador"
                    onpaste="return false" :max="item.max" :required="item.requerido" :placeholder="item.placeholder" />

                <div v-else>
                    <select  v-if="item.tipo != 'file'" :name="item.identificador" :id="item.identificador" :required="item.requerido"
                        :placeholder="item.placeholder">
                        <option value="" selected disabled>
                            {{ item.placeholder }}
                        </option>
                        <option v-for="datacombo in item.datacombo" v-bind:key="datacombo.id" :value="datacombo.valor">
                            {{ datacombo.nombre }}
                        </option>
                    </select>
                </div>
            </div>


            <br />
            <br />
            <input hidden type="submit" id="Secondform" />
        </form>
    </div>
</template>


<style scoped>
#data-personal {
    margin-top: 2vw;
}

.param-data-personal select {
    width: 104% !important;
    border-style: solid;
    border-width: 0.15vw;
}

.param-data-personal input:focus {
    outline: 0;
    border-color: var(--colorP);
}

.param-data-personal label {
    font-weight: bold;
}

.param-data-personal {
    display: inline-grid;
    width: 40%;
    margin: 1vw 7vw 0vw 1vw;
}

.param-data-personal input,
select {
    width: 100%;
    margin: 1vw 0.2vw;
    height: 2.5vw;
    border-radius: 6px;
    border-color: #31353552;
    padding: 0px 0px 0px 14px;
    border-style: solid;
    font-size: 1vw;
}

@media screen and (max-width: 768px) {
    .param-data-personal {
        width: 100%;
    }

    .param-data-personal input,
    select {
        height: 45px;
        border-radius: 8px;
        margin-bottom: 4vw;
        font-size: 4vw;

    }
}
</style>
